export default {
    manage_fuelCard: "Fuel Card",
    manage_fuelCard_cardNumberColumnTitle: "Fuel Card",
    manage_fuelCard_vehicleColumnTitle: "Vehicle",
    manage_fuelCard_vehicleDescriptionColumnTitle: "Vehicle Description",
    manage_fuelCard_unitOrDriverColumnTitle: "Unit / Driver",
    manage_fuelCard_tankSizeColumnTitle: "Tank Size (Value in Gallons)",
    manage_fuelCard_search_by_fuel_card_number: "Search by Fuel Card or Tank Size"
}